import CalendarInputInline from './CalendarInputInline'

export default CalendarInputInline
